import React, { useContext, useState } from "react";
import { UserContext, BaseUrl } from "../../App.js";
import Axios from "axios";
import classes from "./ChangeUserPhoto.module.css";
import Button from "../../UI/Button/Button";

function ChangeUserPhoto(props) {
  const [user] = useContext(UserContext);
  const [file, setFile] = useState(null);
  const { logOutCallback } = props;

  const handleSubmit = async (event) => {
    event.preventDefault();
    (async function () {
      if (file) {
        const formData = new FormData();
        formData.append("person_name", `${localStorage.getItem("userName")}`);
        formData.append("photo", file, "photo");

        const photoUpdate = await Axios.patch(
          `${BaseUrl}/user/image`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              authorization: `Bearer ${user.accesstoken}`,
            },
          }
        );
        setFile(null);
        if (photoUpdate.data.status === "success") logOutCallback();
      }
    })();
  };

  const handleChange = (event) => {
    const blob = new Blob([event.target.files[0]], { type: "image/jpeg" });
    setFile(blob);
  };

  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      <div className={classes.Container}>
        <div className={classes.ImgContainer}>
          <img
            className={classes.Img}
            src={`https://userspictures.s3.us-east-2.amazonaws.com/${localStorage.getItem(
              "userImage"
            )}`}
          />
        </div>
        <label htmlFor="photo"></label>
        <div className={classes.FileUpload}>
          <input
            style={{ outline: "none" }}
            onChange={handleChange}
            type="file"
            name="photo"
            id="photo"
            accept="image/*"
          />
        </div>
        <Button type="submit">Save Photo</Button>
      </div>
    </form>
  );
}

export default ChangeUserPhoto;
